class SubscriptionSelector extends HTMLElement {
    connectedCallback() {
        if (this.initialized) return
        this.initialized = true

        const circle = this.querySelector('[data-circle]')
        if (!circle) return

        gsap.set(circle, {
            y: 100,
            transformOrigin: 'center center'
        })

        gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'top center',
                end: 'top bottom',
                scrub: 2
            }
        })
            .to(circle, {
                y: 0,
                scale: 1,
                ease: 'none'
            })
    }
}

customElements.define('subscription-selector', SubscriptionSelector)
